import { render, staticRenderFns } from "./GeneratedPosterPage.vue?vue&type=template&id=f6081b6c&scoped=true"
import script from "./GeneratedPosterPage.vue?vue&type=script&lang=js"
export * from "./GeneratedPosterPage.vue?vue&type=script&lang=js"
import style0 from "./GeneratedPosterPage.vue?vue&type=style&index=0&id=f6081b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6081b6c",
  null
  
)

export default component.exports